<div class="setup-dialog">
  <mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="selectedIndex = $event">

    <mat-tab label="{{ 'INIT.WELCOME' | translate }}">
      <br>
      <br>
      <p>{{ 'INIT.WELCOME_TEXT' | translate }}</p>
      <br>
      <div class="row m-0">
        <div class="col-md-12">
          <img class="profile-image" vlink="image.png" [cache]="false" [model]="fourD.activeTeam" [alt]="fourD.activeTeam.name">
        </div>
      </div>
      <div class="row m-0">
        <div class="col-md-12">
          <label for="image-change">
              <a mat-raised-button color="primary" class="profile-image">{{'PROFILE.CHANGE_IMAGE' | translate }}</a>
          </label>
          <input id="image-change" type="file" (change)="uploadFile($event)" placeholder="{{'PROFILE.UPLOAD_FILE' | translate }}" accept=".png,.jpg,.jpeg" hidden="true">
        </div>
      </div>
      <div class="row m-0">
        <div class="col-12 text-right"><button mat-raised-button (click)="nextStep()">{{ 'GENERIC.NEXT' | translate }}</button></div>
      </div>

    </mat-tab>

    <mat-tab label="{{ 'INIT.CONNECTIONS' | translate }}">
        <br/>
        <p>{{ 'INIT.STEP_NETWORK_MSG' | translate }}</p>
        <h6>{{ 'INIT.STEP_NETWORK_AVAIL' | translate }}</h6>
        <br/>
        <mat-accordion>
            
          <mat-expansion-panel 
              *ngFor="let interface of networkInterfaces" 
              (opened)="setNetwork(interface)"
              [className]="selectedInterface && selectedInterface.name == interface.name ? 'selected-bg mat-expansion-panel' : 'normal-bg mat-expansion-panel'">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      {{interface.name}}
                  </mat-panel-title>
                  <mat-panel-description>
                      {{interface.ip4 }}
                  </mat-panel-description>
              </mat-expansion-panel-header>

              <p>{{ 'INIT.STEP_NETWORK_ADV' | translate }}</p>
              <mat-form-field class="w-100" appearance="outline">
                  <mat-label>{{'INIT.IP' | translate }}</mat-label>
                  <input matInput [formControl]="addressControl" type="text" name="address" required >
              </mat-form-field>
              <mat-form-field class="w-100" appearance="outline">
                  <mat-label>{{'INIT.NETMASK' | translate }}</mat-label>
                  <input matInput [formControl]="netmaskControl" type="text" name="netmask" required >
              </mat-form-field>
              <mat-form-field class="w-100" appearance="outline">
                  <mat-label>{{'INIT.GATEWAY' | translate }}</mat-label>
                  <input matInput [formControl]="gatewayControl" type="text" name="gateway" >
              </mat-form-field>
              <button mat-raised-button (click)="networkSetup(interface)" [disabled]="!addressControl.valid || !netmaskControl.valid">{{ 'GENERIC.CHANGE' | translate }}</button>
              

          </mat-expansion-panel>
      </mat-accordion>
      <br>
      <div class="row m-0">
        <div class="col-12 text-right"><button mat-raised-button (click)="nextStep()">{{ 'GENERIC.NEXT' | translate }}</button></div>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'INIT.USERS' | translate }}">
      <br>
      <p>{{ 'INIT.STEP_USERS_MSG' | translate }}</p>

      <div class="row m-0">
        <div class="col-md-8">
            <mat-form-field>
              <mat-label>{{ 'INIT.STEP_USERS_AG' | translate }}</mat-label>
              <mat-select [(value)]="invite.group">
                <mat-option *ngFor="let group of groups" [value]="group">
                    {{ 'USER_ADMIN.' + service.getAccessGroupSufix(group.uid, fourD.activeTeam.uid) | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
      </div>

      <div class="row m-0">
        <div class="col-md-8">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{'SIGNIN.EMAIL' | translate }}</mat-label>
              <input matInput [(ngModel)]="invite.email" type="text" name="email" >
            </mat-form-field>
        </div>
      </div>

      <button mat-raised-button (click)="sendInvite()">{{ 'GENERIC.SEND' | translate }}</button>

      <div class="row m-0">
        <div class="col-12 text-right"><button mat-raised-button (click)="closeDialog()">{{ 'GENERIC.FINISH' | translate }}</button></div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>